import { gqlSystemRoleCode as SYSTEM_ROLE } from '@minecraft.graphql-types';
import { parseJwt } from '@blocs.auth';
import { NavigateOptions } from '@blocs.router';
import { GET_USER_STATUS, GET_USER_STEP } from 'graphqls/profile';
import routeHelper from 'src/routes/helper';

export const VerifiedAccountRedirect = (
  token,
  client,
  redirectToOnBoarding = true,
  navigate: (options: NavigateOptions) => void
): void => {
  const parsedToken = parseJwt(token);
  const isPC = parsedToken?.roles && parsedToken.roles.includes(SYSTEM_ROLE.PROJECT_CREATOR);

  if (isPC) {
    navigate({ to: routeHelper.projectCreatorInformation.href() });
  } else {
    client.cache.writeQuery({
      query: GET_USER_STATUS,
      data: {
        isVerified: true,
      },
    });

    client.cache.writeQuery({
      query: GET_USER_STEP,
      data: {
        onboardingStep: '',
      },
    });

    if (redirectToOnBoarding) navigate({ to: routeHelper.onboarding.href() });
  }
};
